import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmployeeCrudRoutingModule } from './employee-crud-routing.module';
import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { ViewComponent } from './view/view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { NgxMaskModule } from 'ngx-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TeamTaskReportComponent } from './team-task-report/team-task-report.component';


@NgModule({
  declarations: [
    AddComponent,
    ListComponent,
    ViewComponent,
    TeamTaskReportComponent
  ],
  imports: [
    CommonModule,
    EmployeeCrudRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    SwiperModule,
    PipeModule,
    NgxDatatableModule,  
    NgxMaskModule.forRoot(),
    NgxSpinnerModule,
    MatMenuModule,
    MatSlideToggleModule

  ]
})
export class EmployeeCrudModule { }
